module.exports = __webpack_public_path__ + "240e0b25c0d0ccedaba900e0b94235a8.svg";